const faqs = [
  {
    q: '51动漫网需要注册才能看动漫吗？',
    a: '不需要。51动漫网所有内容完全免费开放，无需注册账号即可直接在线阅读全部动漫作品，没有任何使用门槛。',
  },
  {
    q: '网站上的动漫资源更新频率是怎样的？',
    a: '我们与各大动漫平台保持同步更新节奏。热门连载作品通常在官方更新后2小时内即可在51动漫网上阅读，每日更新超过100话。',
  },
  {
    q: '支持哪些类型的动漫作品？',
    a: '51动漫网收录日漫、国漫、韩漫三大语系动漫，涵盖热血、恋爱、奇幻、悬疑、科幻、校园、治愈、异世界等全部主流类型，总计超过5000部作品。',
  },
  {
    q: '在手机上阅读体验好吗？',
    a: '非常好。51动漫网专为移动端优化了下拉式阅读模式，无需翻页等待，流畅的纵向滚动让追漫体验更加沉浸。手机浏览器直接访问即可，无需下载任何应用。',
  },
  {
    q: '51动漫网站和51动漫官网有什么区别？',
    a: '51动漫网站与51动漫官网均指向同一品牌旗下的动漫阅读服务。无论您通过哪个入口访问，都能获得完全一致的海量免费动漫阅读体验。',
  },
  {
    q: '如何获取最新更新的通知？',
    a: '目前您可以将51动漫网添加到浏览器收藏夹，每日访问查看首页的"最新动态快讯"板块，即可第一时间获取所有新番和更新信息。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于51动漫网的常见疑问，这里为您一一解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div key={faq.q} className="bg-background-100 rounded-lg border border-background-200/60 p-5 md:p-6">
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}